/* global angular */
( function () {
	'use strict';

	function ReorderCtrl ( templateModel, isSaving, $modalInstance ) {
		var self = this;

		self.model          = templateModel;
		self.isSaving       = isSaving;
		self.isMoving       = false;
		self.focusGroup     = {};
		self.focusIndicator = {};

		function closeModal () {
			$modalInstance.dismiss( 'cancel' );
		}

		function showCancelButton () {
			return self.isMoving;
		}

		function reset () {
			self.focusGroup     = {};
			self.focusIndicator = {};
			self.isMoving       = false;
		}

		reset();

		self.closeModal       = closeModal;
		self.showCancelButton = showCancelButton;
		self.reset            = reset;
	}

	angular
		.module( 'app.templates' )
		.controller( 'ReorderCtrl', ReorderCtrl );

	ReorderCtrl.$inject = [ 'templateModel', 'isSaving', '$modalInstance' ];
} )( );
